import { Button, Dropdown, Image } from "antd";
import { RefreshIcon } from "../../../../../atoms/CustomIcons";
import { PopUp } from "../../../../../atoms/PopUp";
import HourlyRatesHistory from "../Popups/HourlyRatesHistory";
import { useEffect, useState } from "react";
import LaborRatesReminder from "../Popups/LabourRatesReminder";
import { GetLaborRatesType } from "../../ducks/types";
import dayjs from "dayjs";
import { MoreOutlined } from "@ant-design/icons";

interface PropsType {
  data: GetLaborRatesType;
  laborRatesId: string;
}

export default function LastActivity(props: PropsType) {
  const { data, laborRatesId } = props;

  const [historyPopUp, setHistoryPopUp] = useState(false);
  const [editReminderPopUp, setEditReminderPopUp] = useState(false);

  useEffect(() => {
    if (data) {
      console.log(data);
    }
  }, [data]);

  const MenuItems = [
    {
      key: "1",
      label: (
        <Button
          type="text"
          className="no-hover"
          icon={<Image src="/images/labor/clock_icon.svg" preview={false} />}
          onClick={(e) => {
            e.stopPropagation();
            setHistoryPopUp(true);
          }}
        >
          View changes history
        </Button>
      ),
    },
    {
      key: "2",
      label: (
        <Button
          type="text"
          className="no-hover"
          icon={<Image src="/images/labor/bell_icon.svg" preview={false} />}
          onClick={(e) => {
            e.stopPropagation();
            setEditReminderPopUp(true);
          }}
        >
          Edit reminder: every {data?.reminder ?? 0} months
        </Button>
      ),
    },
  ];

  const changesHistory = {
    visibility: historyPopUp,
    class: "upload_photo_modal",
    content: (
      <HourlyRatesHistory
        onClose={() => setHistoryPopUp(false)}
        apiSubmit={() => null}
      />
    ),
    width: 900,
    onCancel: () => setHistoryPopUp(false),
  };

  const editReminder = {
    visibility: editReminderPopUp,
    class: "upload_photo_modal",
    content: (
      <LaborRatesReminder
        onClose={() => setEditReminderPopUp(false)}
        laborRatesId={laborRatesId}
        reviseData={data?.reminder ?? 0}
      />
    ),
    width: 640,
    onCancel: () => setEditReminderPopUp(false),
  };

  return (
    <>
      <div className="historyBar">
        <div className="lastUpdate">
          {data?.update_labor_rate_time && (
            <>
              <span className="update_icon">
                <RefreshIcon />
              </span>
              Last update:{" "}
              {dayjs(data?.update_labor_rate_time).format("MMM D, YYYY")}.
            </>
          )}
        </div>

        <Dropdown
          menu={{ items: MenuItems }}
          trigger={["click"]}
          placement="bottomRight"
          className="actionButton"
        >
          <Button
            onClick={(e) => e.stopPropagation()}
            onKeyDown={(e) => e.stopPropagation()}
            style={{
              padding: "6px",
              height: "auto",
              background: "transparent",
            }}
            className="only_icon"
            icon={<MoreOutlined />}
          />
        </Dropdown>
      </div>

      <PopUp {...changesHistory} />
      <PopUp {...editReminder} />
    </>
  );
}
